// Put your application javascript here

$(function () {
  var $finishOptions = $("#paper-finish-options a");

  if ($finishOptions.length) {
    var $input = $("#paper-finish");
    $finishOptions.on("click", function (event) {
      $finishOptions.removeClass("active");
      var $target = $(event.target);
      $target.addClass("active");
      var value = $target.closest("a").data("value");
      $input.val(value);
    });
  }

  $("img").on("contextmenu", function (event) {
    event.preventDefault();
  });

  $("img").prop("draggable", false);
});

$(function () {
  var $originalSelect = $('select[name="id"]');
  $originalSelect.on("change.themeProductOptions", function (e, v) {
    console.log(e, v);

    if (v.featured_image && v.featured_image.src) {
      var src = v.featured_image.src.replace("http:", "");
      var oldImage = $(".theme-img img");
      var parent = oldImage.parent();

      var newImg = $(
        '<img class="lazyload lazypreload fade-in img-zoomable"' +
          'src="' +
          oldImage.prop("src") +
          '"' +
          'data-src="' +
          src +
          '"' +
          'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
          'data-aspectratio="' +
          oldImage.prop("data-aspectratio") +
          '"' +
          'data-sizes="auto"' +
          'alt="">'
      );

      oldImage.remove();
      parent.append(newImg);
    }
  });
  /**
   * <img class="lazyload lazypreload fade-in img-zoomable"
              data-src="{{ img_url }}"
              data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"
              data-aspectratio="{{ image.aspect_ratio }}"
              data-sizes="auto"
              {% comment %} data-original="{{image |  img_url: '1080x'}}" {% endcomment %}
              alt="{{ image.alt | escape }}">
   * 
   * 
   *  */
});
